import apiFF from "app/services/fastfrete-api/apiFF"
import {Constants} from 'app/utils/Constants';

export function login(email, password) {
    return apiFF.post(`${Constants.baseUrl}/auth`, {email, password});
}

export function getMe() {
    return apiFF.get(`${Constants.baseUrlV2}/me`);
}

export function esqueciSenha(data) {
    return apiFF.post(`${Constants.baseUrl}/esqueci-senha`, data);
}

export function alterarSenha(data) {
    return apiFF.post(`${Constants.baseUrl}/alterar-senha`, data);
}

export function sms(id) {
    return apiFF.get(`${Constants.baseUrl}/sms/${id}`);
}

export function verificarEmail(token) {
    return apiFF.post(`${Constants.url}/api/v2/email/verify`, { token });
}

export function verificarStatusEmail() {
    return apiFF.get(`${Constants.url}/api/v2/web/admin/email/verify/status`);
}

